import { Box, styled } from "@mui/material";

interface GaugeFrameProps {
  gaugeWidth: number;
  gaugeHeight: number;
}

export const GaugeFrame = styled(Box, { shouldForwardProp: (prop) => prop !== "gaugeWidth" && prop !== "gaugeHeight" })<GaugeFrameProps>(
  ({ gaugeWidth, gaugeHeight }) => ({
    position: "relative",
    height: "90%",
    aspectRatio: `${gaugeWidth} / ${gaugeHeight}`,

    // Shrink the chart when it's in a zoomed modal
    ".zoomable-grid-card-container &": {
      height: "72%",
    },
  })
);

export const IconGlyph = styled("svg")(() => ({
  ".zoomable-grid-card-container &": {
    transform: "scale(0.7)",
    transformOrigin: "center",
  },
}));
